
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CourseList.css";

function CourseList() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL+"/api/courses")
      .then((res) => res.json())
      .then((data) => setCourses(data))
      .catch((err) => console.error("Error fetching courses:", err));
  }, []);

  // Timeline definitions
  const timeline5Days = [
    "Day 1: Documentation + Theory",
    "Day 2: Theory",
    "Day 3: Test + Simulation basic drone assembly",
    "Day 4: Hands on flying + Night flying",
    "Day 5: Hands on flying + Test",
  ];

  const timeline8Days = [
    "Day 1: Documentation + Theory",
    "Day 2: Theory",
    "Day 3: Test + Simulation basic drone assembly",
    "Day 4: Hands on flying + Night flying",
    "Day 5: Hands on flying + Test",
    "Day 6: Test + Simulation",
    "Day 7: Hands on flying + Night flying",
    "Day 8: Hands on flying + Test",
  ];

  // ✅ Circle section data (same as Certificate.jsx)
const highlights = [
  { 
    id: 1, 
    src: "/Add on Course Images/IMG_6269.jpeg", 
    title: "Student Accommodation", 
    desc: "50+ students accommodated at a time" 
  },
  { 
    id: 2, 
    src: "/Add on Course Images/WhatsApp Image 2025-06-06 at 1.47.53 PM.jpeg", 
    title: "Simulator Room", 
    desc: "Exclusive simulator training experience" 
  },
  { 
    id: 3, 
    src: "/1.jpg", 
    title: "Hands-on Practice", 
    desc: "Exclusive Flying with Expert Instructors"
  },
  { 
    id: 4, 
    src: "/Add on Course Images/WhatsApp Image 2025-07-08 at 8.25.28 PM.jpeg", 
    title: "Modern Equipment", 
    desc: "6 Type certificate Drones"
  },
  { 
    id: 5, 
    src: "/Add on Course Images/library.jpg", 
    title: "Knowledge Hub", 
    desc: "Organized Library Setup" 
  },
];
  return (
    <div>
      {/* Courses Section */}
      <div className="courses-container">
        {courses.map((course) => (
          <div className="course-card" key={course._id}>
            <h2>{course.name}</h2>
            <img
              src={course.image ? process.env.REACT_APP_API_URL+`${course.image}` : "/placeholder.png"}
              alt={course.name}
            />
            <p>
              <span className="label">Duration:</span> {course.days} days
            </p>
            <p>
              <span className="label">Investment:</span> {course.price} + {course.gst}
            </p>
            <p className="label">DESCRIPTION</p>
            <p>{course.description}</p>
            <br></br>
            <button
              className="apply-btn"
              onClick={() => navigate(`/course-enroll-template/${course._id}`)}
            >
              Apply Now
            </button>
          </div>
        ))}
      </div>

      {/* Common Professional Timeline Section */}
      <div className="common-timeline-section">
        <h2>Course Learning Timeline</h2>
        <p>
          Our programs follow a structured professional timeline. Below are the
          modules for 5-day and 8-day courses:
        </p>

        <div className="timeline-wrapper">
          <div className="timeline-box">
            <h3>5-Day Course Timeline</h3>
            <div className="timeline">
              {timeline5Days.map((day, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">{day}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="timeline-box">
            <h3>8-Day Course Timeline</h3>
            <div className="timeline">
              {timeline8Days.map((day, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">{day}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Circle Highlights Section */}
      <h1 className="circle-heading">Learning Environment</h1>
      <div className="circle-container">
        {highlights.map((item) => (
          <div className="circle-card" key={item.id}>
            <img src={item.src} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
      <br></br>
      <br></br>
    </div>
  );
}

export default CourseList;

